import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { AddUserToDataAlertScope } from '../../../ts/controllers/AddUserToDataAlertCtrl';
import { RemoveUserFromDataAlertScope } from '../../../ts/controllers/RemoveUserFromDataAlertCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

export interface AddUserToDataAlertProviderProps extends ReactDirectiveProps {
  readonly dataAlertId: string;
}

const AddTemplate = `<div ng-controller="AddUserToDataAlertCtrl" ng-include="'addRemoveUserFromDataAlert.html'"></div>`;
const RemoveTemplate = `<div ng-controller="RemoveUserFromDataAlertCtrl" ng-include="'addRemoveUserFromDataAlert.html'"></div>`;

export class AddUserToDataAlertProvider extends React.Component<AddUserToDataAlertProviderProps> {
  public render() {
    return (
      <div>
        <AngularDirective
          template={AddTemplate}
          angularContext={this.props.angularContext}
          setupScope={this.setupScope}
        />
      </div>
    );
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as AddUserToDataAlertScope;
    childScope.dataAlertId = this.props.dataAlertId;
    return childScope;
  }
}

export class RemoveUserFromDataAlertProvider extends React.Component<AddUserToDataAlertProviderProps> {
  public render() {
    return (
      <div>
        <AngularDirective
          template={RemoveTemplate}
          angularContext={this.props.angularContext}
          setupScope={this.setupScope}
        />
      </div>
    );
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as RemoveUserFromDataAlertScope;
    childScope.dataAlertId = this.props.dataAlertId;
    return childScope;
  }
}
